<template>
	<div>
		<section class="overflow-y-scroll max-h-[65vh] py-5 px-7">
			<slot />
		</section>

		<footer
			v-if="hasFooter"
			class="py-3.5 px-7"
		>
			<slot name="footer" />
		</footer>
	</div>
</template>

<script setup lang="ts">

const slots = useSlots();
const hasFooter = computed(() => Boolean(slots.footer));

</script>
